import { useEffect } from "react";
import { formatSize } from "../../pages/pitchTempoUtils";
import { outputInfo } from "../../lib/audioExportFormats";

const labels = { bitrate_kbps: "Bitrate", bit_depth: "Profundidad", compression_level: "Compresion FLAC", vbr_quality: "Calidad VBR" };
const labelValue = (key, value) => key === "bitrate_kbps" ? `${value} kbps` : key === "bit_depth" ? `${value} bits` : String(value);

export default function AudioExportControls({ settings, source, disabled = false, id = "export-format" }) {
  const { catalog, selected, format, setFormat, quality, changeQuality, error } = settings;
  const info = outputInfo(selected, quality, source);
  useEffect(() => {
    if (source?.channels && selected && source.channels > selected.max_channels) {
      const compatible = catalog.formats.find(item => item.can_encode && source.channels <= item.max_channels);
      if (compatible) setFormat(compatible.id);
    }
  }, [catalog, selected, setFormat, source?.channels]);
  return <div className="min-w-0 max-w-full space-y-2">
    <div className="flex flex-wrap items-center gap-2">
      <label htmlFor={id} className="text-sm text-muted-foreground">Formato</label>
      <select id={id} value={format} onChange={event => setFormat(event.target.value)} disabled={disabled || !catalog}
        className="h-11 min-w-0 max-w-full rounded border border-border bg-panel px-2 text-sm text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal">
        {!catalog && <option value={format}>Consultando formatos...</option>}
        {catalog?.formats.map(item => <option key={item.id} value={item.id} disabled={!item.can_encode || (source?.channels || 2) > item.max_channels} title={item.unavailable_reason || undefined}>
          {item.name} · .{item.extension} · {item.lossless ? "sin perdidas" : "con perdidas"}{!item.can_encode ? " · no disponible" : ""}
        </option>)}
      </select>
      {Object.entries(selected?.quality_options || {}).map(([key, config]) => <label key={key} className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
        {labels[key]}
        <select aria-label={labels[key]} value={quality[key] ?? config.default} disabled={disabled}
          onChange={event => changeQuality(key, event.target.value)} className="h-11 rounded border border-border bg-panel px-2 text-sm text-foreground">
          {config.default === "source" && <option value="source">Fuente compatible</option>}
          {config.values.map(value => <option key={value} value={value}>{labelValue(key, value)}</option>)}
        </select>
      </label>)}
    </div>
    {error && <p role="alert" className="text-xs text-destructive">{error}</p>}
    {catalog?.formats.filter(item => !item.can_encode).map(item => <p key={item.id} className="break-words text-xs text-brass">{item.name}: {item.unavailable_reason}</p>)}
    {info && <p className="break-words text-xs text-muted-foreground">
      {info.rate ? `${info.rate.toLocaleString()} Hz` : "Frecuencia: fuente"} · {info.channels ? `${info.channels} ${info.channels === 1 ? "canal" : "canales"}` : "Canales: fuente"}
      {info.bytes ? ` · ${info.upperBound ? "Hasta " : info.approximate ? "~" : ""}${formatSize(info.bytes)}` : ""}
      {!info.compatible ? ` · Este formato admite hasta ${selected.max_channels} canales` : ""}
    </p>}
    {selected?.lossless && source && <p className="text-xs text-muted-foreground">{catalog?.lossless_notice}</p>}
  </div>;
}
